import React, { PropsWithChildren } from "react";
import styled from "styled-components";

interface WrapperProps {
  marginTop?: boolean;
  color?: string;
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
`;

const MiniLabelStyle = styled.div<WrapperProps>`
  font-size: var(--global-font-size-xs);
  color: ${(props: WrapperProps) => {
    if (props.color) {
      return props.color;
    } else {
      return `inherit`;
    }
  }};
  line-height: initial;
  margin-left: 0.2rem;
  margin-top: ${(props: WrapperProps) => {
    if (props.marginTop) {
      return `0.3rem`;
    } else {
      return `0rem`;
    }
  }};
`;

const MiniBetaLabel: React.FC<WrapperProps> = (props) => {
  return <MiniLabelStyle {...props}>beta</MiniLabelStyle>;
};

export const Beta: React.FC<PropsWithChildren<WrapperProps>> = (props) => {
  return (
    <Wrapper>
      {props.children}
      <MiniBetaLabel {...props} />
    </Wrapper>
  );
};
